import React from "react";
import styles from "./box.module.scss";
import family from '../../../assets/family.JPG'
import family_3 from '../../../assets/family_3.jpg'
import { Link } from "react-router-dom";

const Box = () => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={family} alt='MILLENSYS family' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='/about' className={styles._headding}>
              About MILLENSYS
              </Link>
              <strong className={styles.__strong}>
              MILLENSYS , a private held joint stock company, registered in Egypt, USA, Saudi Arabia and Kenya,
              </strong>
              <p className={styles.__content}>
              "MILLENSYS is a pioneering leader in healthcare software and IT solutions, dedicated to delivering innovative solutions
              that empower healthcare service providers to optimize their daily operations swiftly, securely, and efficiently.
              Our mission is to enable operational excellence, enhance patient and stakeholder satisfaction, elevate service quality,
              and drive profitability within the healthcare industry.
              </p>
              <p className={styles.__content}>
                Our comprehensive suite of software solutions caters to a wide spectrum of healthcare entities, including hospitals,
                medical centers, polyclinics, diagnostic centers, radiology scan centers, laboratories, health insurance organizations, 
                billing and claim management firms, as well as telehealth, teleradiology, and telemedicine companies. 
                We are committed to helping these organizations manage their operations with the utmost professionalism.
              </p>
            </div>
          </div>
        </div>

        {/* Box 2  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='/about' className={styles._headding}>
              MILLENSYS
              </Link>
              <strong className={styles.__strong}>
              MILLENSYS unified eHealth platform includes a scalable electronic health record "EHR" or "HMIS, Vendor neutral archive "VNA"
              </strong>
              <p className={styles.__content}>
              MILLENSYS' unified eHealth platform encompasses a scalable Electronic Health Record (EHR) or Hospital Management Information System 
              (HMIS), a Vendor-Neutral Archive (VNA) tailored for enterprise imaging in hospitals, Radiology Picture Archiving and Communication 
              Systems (PACS), DICOM Viewers, and Information Systems (RIS) designed specifically for radiology departments. Additionally,
              we provide Laboratory Information Systems (LIS) and lab automation solutions for laboratories,
              catering to various specialties such as orthopedics, gastroenterology, dermatology, dental, cardiology, oncology, and more. 
              </p>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={family_3} alt='MILLENSYS' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Box;
